/**
 * @file index.tsx
 *
 * @fileoverview When a search yields no results we show an empty search.
 */

import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Link from '~/jobiqo/components/Link';
import { Box } from '~/vcl/atoms/07-box';
import { EmptyElement } from '~/vcl/molecules/02-empty';
import { NewsletterIcon } from '~/vcl/icons/Newsletter';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import UndoAltSolidIcon from '~/vcl/icons/UndoAltSolid';
import { Slottable } from '~/jobiqo/components/Slots/interfaces';

interface JobSearchNoResultsSlotProps {
  /**
   * The URL to go for resetting the current search.
   */
  resetUrl: Slottable<string>;

  /**
   * The message and alert toggle that shows up inside the box.
   */
  children: Slottable<React.ReactNode>;
}

export const JobSearchNoResultsSlot = ({
  resetUrl,
  children,
}: JobSearchNoResultsSlotProps) => {
  const intl = useIntl();

  return (
    <>
      <div>
        <h1 data-test-id="empty_search_title">
          <FormattedMessage
            id="empty_search_title"
            defaultMessage={`No results found for this search.`}
          />
        </h1>
      </div>
      <Box>
        <EmptyElement
          icon={<NewsletterIcon title="newsletter" />}
          iconWidth="300"
          iconHeight="180"
          iconColor="primary"
        >
          <Spacing />
          {children}
          <Link href={resetUrl}>
            <>
              <UndoAltSolidIcon
                aria-hidden="true"
                width="15"
                height="15"
                title={intl.formatMessage({
                  id: 'undo',
                  defaultMessage: 'Undo',
                })}
              />
              &nbsp;
              <FormattedMessage
                id={'current_search_reset'}
                defaultMessage={'Reset Search'}
              />
            </>
          </Link>
        </EmptyElement>
      </Box>
    </>
  );
};
export default JobSearchNoResultsSlot;
